module.exports = __webpack_public_path__ + "frontend/img/emotionalTransferability.49844408.svg";